<template>
    <button
        class="button button-with-icon pointer position--relative background--transparent"
        :class="{ 'disable': loading }"
        @click="exportsFiles( `${preEndpoint}${endpoint}`, $route.query, filename )"
        @click.middle="exportsFiles( `${preEndpoint}${endpoint}`, $route.query, filename )"
    >
        <slot name="icon"></slot>
        <slot name="counter"></slot>
        <span
            v-if="loading"
            class="loading--square position--absolute"></span>
        <span
            v-if="errorExport"
            class="page__list__message position--absolute background--red color--white"
        >
            {{ $t('error.export') }}
        </span>
        <span
            v-if="emailSent"
            class="page__list__message position--absolute background--blue color--white"
        >
            {{ $t('global.emailSentExport') }}
        </span>
        <a class="download" download></a>
    </button>
</template>

<script>
// mixins
import exportFiles from '@/helpers/mixins/files/exportFiles';

export default {
    mixins: [ exportFiles ],
    props: {
        endpoint: String,
        preEndpoint: {
            default: '/exports',
            type: String
        },
        filename: String,
        title: String
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // loadings - animations
    // =============================================================================
    @include keyframes ( spin ) {
        0% {
            @include transform( scale( 1 ) );
            opacity: 0;
        }
        50% {
            @include transform( scale( 1.1 ) );
        }
        100% {
            @include transform( scale( 1 ) );
            opacity: 0.75;
        }
    }

    .loading {
        &--square {
            @include transform-position( 0, 0, 0, 0 );
            @include dimensions( 100%, 100% );
            background: $color-blue;
            @include rounded-corner( 5px );
            @include animation( spin 1s infinite linear );
            z-index: -1;
        }
    }

    .page {
        &__list {
            &__message {
                z-index: 1;
                padding: 5px;
                @include dimensions( 166px, auto );
                @include rounded-corner( 5px );
                @include transform-position( false, false, -50px, 50%, translateX( -50% ) );
                @include typography-specs( 14px, 17px);
            }
        }
    }
</style>